export default __webpack_public_path__ + "static/media/metallic.c5a75a26.png";